import React from "react";
import PositionList from "../PositionList";
import Util from "../../util";
import NHeader from "../NHeader";
import NavigatorMain from "../NavigatorMain";
import "./changefunddetail.css";
class ChangeFundDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {}
  }
  componentDidMount() {
    document.title= "调仓记录";
    const successCallback = (data) => {
      if (data && data.code === "0000") {
        this.setState(data.content);
      } else {
        console.log("后台返回数据有误！" + data.message);
      }
    };
    const errorCallback = (err) => {};
    const param = { superFundCode: this.props.location.state.superFundCode, version: this.props.location.state.version };
    const getData = async () => {
      Util.get(Util.url + "/api/v1/superfund/product/adjustment/geSuperFundAdjustmentDetail", param, successCallback, errorCallback);
    };
    getData();
  }

  renderItem = (item) => (
    <div className="CFD_item_container" key={item.fundCode}>
      <div>
        <div className="CFD_item_fundname">{item.fundName}</div>
        <div className="CFD_item_fundcode">{item.fundCode}</div>
      </div>
      <div className="CFD_item_change">
        <span>{Util.toPercent(item.beforeRate)}</span>
        <img style={{ margin: "0 .1rem", width: ".24rem" }} src={require("../../img/n_icon_position_arrow@2x.png")} />
        <span className="CFD_item_aftervalue">{Util.toPercent(item.afterRate)}</span>
      </div>
    </div>
  );
  header = (v) => (
    <div className="CFD_Pie_header" style={{ background: Util.pieEchartsFundListColorMap.get(v.styleTypeName) }}>
      <span className="CFD_Pie_header_title">{v.styleTypeName}</span>
      <div className="CFD_Pie_header_value">
        <span>{Util.toPercent(v.beforeTotalRate)}</span>
        <img style={{ margin: "0 .1rem", width: ".24rem" }} src={require("../../img/n_icon_position_arrow@2x.png")} />
        <span>{Util.toPercent(v.afterTotalRate)}</span>
      </div>
    </div>
  );
  render() {
    const { adjustmentItemList = [], effectDateStr ,adjustReason} = this.state;
    return (
      <div className="CFD_container" style={{ minHeight: window.winHeight }}>
        <NavigatorMain>
          <NHeader title="调仓记录" isPaddingBottom={0}/>
        </NavigatorMain>
        <div className="CFD_content">
          <div className="CFD_reason">
            <div className="CFD_data">{effectDateStr}</div>
            <div className="CFD_reason_content">
              <div className="CFD_reson_title">调仓原因</div>
              <div className="CFD_reason_body">{adjustReason}</div>
            </div>
          </div>
          {adjustmentItemList.map((v) => {
            return <PositionList key={v.styleType} background={Util.pieEchartsFundListBgColorMap.get(v.styleTypeName)} header={this.header(v)} renderItem={this.renderItem} dataSource={v.itemAdjustHistory} topDistance=".1rem" bottomDistance=".1rem" />;
          })}
        </div>
      </div>
    );
  }
}
export default ChangeFundDetail;



// WEBPACK FOOTER //
// ./src/components/fundDetail/ChangeFundDetail.js